import {
  Dialog, DialogTitle, DialogContent, DialogActions, IconButton, MenuItem, Select,
  Avatar,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useApi, useCurrentUser } from 'lib/contexts/ApplicationState';

interface Props {
  onBack: () => void;
  onClose: () => void;
  onNext: () => void;
  onChange: (pagename: string) => void;
  pagename: string;
}

export const LinkedInPage = ({
  onBack, onClose, onNext, onChange, pagename,
}: Props) => {
  const currentUser = useCurrentUser();
  const api = useApi();
  const [pages, setPages] = useState<any[]>([]);
  const [profile, setProfile] = useState<any>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getPages = async () => {
      const response = await api.getCurrentUsersPages();
      setPages(response.pages);
      setProfile(response.profile);
      setLoading(false);
    };

    getPages();
  }, [api, currentUser]);

  return (
    <Dialog fullWidth onClose={onClose} aria-labelledby="title" open>
      <div className="absolute right-2 top-2">
        <IconButton aria-label="close" onClick={onClose}>
          <Close />
        </IconButton>
      </div>
      <DialogTitle id="title">Import LinkedIn Page</DialogTitle>
      <DialogContent>
        Connect your LinkedIn Account to import from your admined pages.
        You can connect your LinkedIn via the settings page.
        <br />
        <br />
        Select a LinkedIn page to import from:
        {(!loading && !!pages.length) ? (
          <Select
            labelId="list-label"
            fullWidth
            id="list-select"
            name="list-select"
            onChange={(e) => onChange(e.target.value)}
            size="small"
            value={pagename}
          >
            {profile && (
              <MenuItem value={profile.username} key={profile.id}>
                <Avatar src={profile.avatarUrl} className="mr-2" />
                {profile.displayName}
              </MenuItem>
            )}
            {pages.map((page) => (
              <MenuItem key={page.id} value={page.username}>
                <Avatar src={page.avatarUrl} className="mr-2" />
                {page.name}
              </MenuItem>
            ))}
          </Select>
        ) : 'No pages connected'}
      </DialogContent>
      <DialogActions>
        <button type="button" className="btn-primary-outlined" onClick={onBack}>
          Back
        </button>
        <button
          type="button"
          className="btn-primary"
          onClick={onNext}
          disabled={!pagename || loading}
        >
          Next
        </button>
      </DialogActions>
    </Dialog>
  );
};
